import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, createSlots as _createSlots, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "portal_main_page" }
const _hoisted_2 = { class: "main_block main_block--white main_block--first" }
const _hoisted_3 = { class: "col-xs-12 col-sm-6 column justify-between" }
const _hoisted_4 = { class: "image col-xs-0 col-sm-6" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "main_block main_block--search" }
const _hoisted_7 = { class: "main__container--max-width" }
const _hoisted_8 = { class: "row justify-center s-input--main_search--wrapper" }
const _hoisted_9 = { class: "col-xs-12 col-sm-10" }
const _hoisted_10 = { class: "main_block" }
const _hoisted_11 = { class: "main__container--max-width main_block--bottom_divider s-pb-xl" }
const _hoisted_12 = { class: "main_block" }
const _hoisted_13 = { class: "main__container--max-width" }
const _hoisted_14 = {
  key: 0,
  class: "main_block main_block--white"
}
const _hoisted_15 = { class: "main__container--max-width" }
const _hoisted_16 = { class: "statistics-public-block" }
const _hoisted_17 = { class: "about--project-kmns row main_block" }
const _hoisted_18 = { class: "main__container--max-width" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_s_btn = _resolveComponent("s-btn")!
  const _component_q_skeleton = _resolveComponent("q-skeleton")!
  const _component_q_btn_toggle = _resolveComponent("q-btn-toggle")!
  const _component_s_icon = _resolveComponent("s-icon")!
  const _component_s_input = _resolveComponent("s-input")!
  const _component_service_list = _resolveComponent("service-list")!
  const _component_news_list = _resolveComponent("news-list")!
  const _component_user_list = _resolveComponent("user-list")!
  const _component_issue_list = _resolveComponent("issue-list")!
  const _component_issue_dep_list = _resolveComponent("issue-dep-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["main__container--max-width header-card row", { 'main__background--image': _ctx.isMobile }])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: _normalizeClass(["title", { 'title--mobile': _ctx.isMobile }])
          }, _toDisplayString(_ctx.t('systemTypeFull')) + " " + _toDisplayString(_ctx.t('systemName')), 3),
          _createElementVNode("div", null, [
            (!_ctx.isLoading)
              ? (_openBlock(), _createBlock(_component_s_btn, {
                  key: 0,
                  type: "secondary",
                  fat: !_ctx.isMobile,
                  label: "Получить поддержку",
                  to: { name: 'services' }
                }, null, 8, ["fat"]))
              : (_ctx.isLoading && !_ctx.isHydrated)
                ? (_openBlock(), _createBlock(_component_q_skeleton, {
                    key: 1,
                    class: "s-skeleton",
                    width: "200px",
                    type: "QBtn",
                    animation: "fade"
                  }))
                : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass(["main_background", { 'main_background--mobile': _ctx.isMobile }])
          }, [
            _createElementVNode("img", {
              class: "main_background--round",
              src: `${_ctx.routerInitialPath}${_ctx.REGION_ENVIRONMENT}/images/background_round.svg`,
              alt: "Узор представителей КМНС"
            }, null, 8, _hoisted_5)
          ], 2)
        ])
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (_ctx.isVisibleAISearch)
              ? (_openBlock(), _createBlock(_component_q_btn_toggle, {
                  key: 0,
                  modelValue: _ctx.activeSearchTypes,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeSearchTypes) = $event)),
                  options: _ctx.SEARCH_MODE_TYPES,
                  "no-caps": "",
                  "toggle-color": "brand",
                  unelevated: "",
                  flat: "",
                  rounded: ""
                }, null, 8, ["modelValue", "options"]))
              : _createCommentVNode("", true),
            (!_ctx.isLoading)
              ? (_openBlock(), _createBlock(_component_s_input, {
                  key: 1,
                  modelValue: _ctx.serviceSearch,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.serviceSearch) = $event)),
                  modelModifiers: { trim: true },
                  clearable: "",
                  label: "Поиск по мерам поддержки",
                  class: "s-input--main_search",
                  onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.goToService()), ["enter"]))
                }, _createSlots({
                  prepend: _withCtx(() => [
                    _createVNode(_component_s_icon, { name: "app:search" })
                  ]),
                  _: 2
                }, [
                  (!_ctx.isMobile)
                    ? {
                        name: "append",
                        fn: _withCtx(() => [
                          _createVNode(_component_s_btn, {
                            label: "Найти",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToService()))
                          })
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1032, ["modelValue"]))
              : (_ctx.isLoading && !_ctx.isHydrated)
                ? (_openBlock(), _createBlock(_component_q_skeleton, {
                    key: 2,
                    class: "s-skeleton",
                    type: "QRange",
                    animation: "fade"
                  }))
                : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_service_list)
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", {
          class: _normalizeClass(["main__title col-xs-12", { 'main__title--mobile': _ctx.isMobile }])
        }, " Новости ", 2),
        _createVNode(_component_news_list)
      ])
    ]),
    (_ctx.isVisibleStatistics)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", {
              class: _normalizeClass(["main__title s-pb-sm", { 'main__title--mobile': _ctx.isMobile }])
            }, " Статистика ", 2),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_user_list, { class: "s-mb-xl" }),
              _createVNode(_component_issue_list, { class: "s-mb-xl" }),
              _createVNode(_component_issue_dep_list, { class: "s-mb-xl" })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", {
          class: _normalizeClass(["main__title col-xs-12", { 'main__title--mobile': _ctx.isMobile }])
        }, " О проекте ", 2),
        _createElementVNode("div", {
          class: _normalizeClass(["caption col-xs-12 col-lg-8", { 'caption--mobile': _ctx.isMobile }])
        }, _toDisplayString(_ctx.t('systemDescription')), 3)
      ])
    ])
  ]))
}